/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Geometry, Point } from 'geojson';
import { AirspaceAuthorisationSettingsDto } from './airspaceAuthorisationSettingsDto';
import { AirspaceJurisdictionLinkDto } from './airspaceJurisdictionLinkDto';
import { FirDto } from './firDto';
import { NotamSourceDto } from './notamSourceDto';
import { RulesetDto } from './rulesetDto';
import { SimpleAuthorityTypeDto } from './simpleAuthorityTypeDto';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

/**
 * We extend here, which we don\'t normally do, so that we can swap out for  subclasses when sending to some FA versions.
 */
export interface AirspaceJurisdictionDto {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The name for this instance which is displayed to users
     */
    name: string;
    identifier?: string;
    /**
     * What level of airspace check is supported
     */
    airspaceCheckSupport: AirspaceJurisdictionDto.AirspaceCheckSupport;
    hasAerodromeData: boolean;
    hasLibrary: boolean;
    hasNotam: boolean;
    /**
     * The URL for the airspace checker that will be used for this jurisdiction
     */
    airspaceCheckerUrl?: string;
    /**
     * Is this instance available for users to use
     */
    enabled: boolean;
    /**
     * What organisation represents the jurisdictions Air Navigation Service Provider
     */
    ansp?: SimpleOrganisationDto;
    /**
     * What organisation represents the jurisdictions Civil Aviation Authority
     */
    caa?: SimpleOrganisationDto;
    /**
     * What organisation represents the jurisdictions Air Traffic Safety Bureau
     */
    atsb?: SimpleOrganisationDto;
    /**
     * What authority type is used to identify a person
     */
    personalIdentifier?: SimpleAuthorityTypeDto;
    /**
     * What authority type is used to identify a company
     */
    companyIdentifier?: SimpleAuthorityTypeDto;
    /**
     * What authority type is used for an operators certificate
     */
    companyOperatorsCertificate?: SimpleAuthorityTypeDto;
    boundary?: Geometry;
    /**
     * An optional default centre point for the view for when switching to this jurisdiction
     */
    defaultCentre?: Point;
    /**
     * An optional default zoom level for the view for when switching to this jurisdiction
     */
    defaultZoom?: number;
    firList: Array<FirDto>;
    notamSourceList: Array<NotamSourceDto>;
    rulesetList: Array<RulesetDto>;
    airspaceDisclaimer?: string;
    hasNotifications: boolean;
    notamIntegrationIdentifier?: AirspaceJurisdictionDto.NotamIntegrationIdentifier;
    linkList: Array<AirspaceJurisdictionLinkDto>;
    authorisationSettingsList: Array<AirspaceAuthorisationSettingsDto>;
    /** @deprecated */
    hasAirspaceChecker: boolean;
}
export namespace AirspaceJurisdictionDto {
    export type AirspaceCheckSupport =
        | 'NONE'
        | 'AUTHORISATION_CHECK'
        | 'AIRSPACE_CHECK';
    export const AirspaceCheckSupport = {
        NONE: 'NONE' as AirspaceCheckSupport,
        AUTHORISATION_CHECK: 'AUTHORISATION_CHECK' as AirspaceCheckSupport,
        AIRSPACE_CHECK: 'AIRSPACE_CHECK' as AirspaceCheckSupport
    };
    export type NotamIntegrationIdentifier = 'ASA';
    export const NotamIntegrationIdentifier = {
        ASA: 'ASA' as NotamIntegrationIdentifier
    };
}
